import React, { useContext } from 'react'

import { BookingConfirmationContext } from '../AppContext'

const BookingComplete = () => {

  const [ selectedProduct ] = useContext(BookingConfirmationContext)

  return (
    <div className='booking-confirmation'>
      <h4>Booking Confirmed</h4>
      <p>Thank you for your booking! I look forward to seeing you at the below date and time.</p>
      <p><b>{selectedProduct.name}</b></p>
      <p>An email has been sent to the email address provided, please check your spam if it has not arrived at your inbox. Any queries in the build up to the photoshoot, please contact me at <a href='mailto:littlemunchkinphotography@hotmail.com'>littlemunchkinphotography@hotmail.com</a></p>
    </div>
  )
}

export default BookingComplete